"use client";

import type { ReactNode } from "react";
import React from "react";

export const SpritePathContext = React.createContext("/sprite.svg");

interface SpritePathProviderProps {
  children: ReactNode;
  value?: string;
}

export const SpritePathProvider: React.FC<SpritePathProviderProps> = ({
  children,
  value = "/sprite.svg",
  ...other
}) => {
  return (
    <SpritePathContext.Provider value={value} {...other}>
      {children}
    </SpritePathContext.Provider>
  );
};
